export default __webpack_public_path__ + "static/media/Avatar-4.ae3f4776.svg";